import React, { useEffect, useState } from "react";
import queryString from 'query-string';

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { formataValidade } from "../../helpers/formats";

// components
import LogoSistema from "../../components/LogoSistema/LogoSistema";

import { useAuth } from "context/auth";

export default function CarteirinhaVeiculo({ history }) {
    const { setLoading, setupSistema } = useAuth();
    const [titleCard, setTitleCard] = useState("Transportador de Entulho")

    var QRCode = require('qrcode.react');

    const [dadoscarteirinha, set_dadoscarteirinha] = useState(null);
    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        setLoading(true);
        api_GET('protocolotransportador/ByNumeroProtocolo/' + params.protocolo).then(result => {
            if (["Cancelado", "Pendente", "Inativo"].includes(result.data.status)) {
                if (result.data.status == "Inativo") {
                    showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                    return;
                } else {
                    showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                    return;
                }
            }

            if (result.data.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG")
                setTitleCard("Transportador de Grandes Geradores")

            let protocolo = result.data;
            let veiculoId = Number(params.veiculo);
            let veiculo = protocolo.protocoloTransportador[0].protocoloTransportadorVeiculo.find(f => f.protocoloTransportadorVeiculo_Id === veiculoId);
            if (!veiculo) {
                showMessage("Aviso", "Veículo não localizado no cadastro.", 'error', null);
                return;
            }
            let _carteirinha = {
                codCadastro: protocolo.codigoCadastro,
                validade: protocolo.dataFimVigencia,
                dataValidadeVeiculo: veiculo.dataValidadeVistoria,
                placa: veiculo.placa,
                documento: protocolo.cpf_Cnpj,
                nome: protocolo.protocoloTransportador[0].razaoSocial,
                endereco: protocolo.protocoloTransportador[0].logradouro + ", " + protocolo.protocoloTransportador[0].numEndereco + ", " + protocolo.protocoloTransportador[0].bairro,
                protocolo: params.protocolo,
                veiculo: params.veiculo,
                status: veiculo.status
            }
            set_dadoscarteirinha(_carteirinha);
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {(dadoscarteirinha != null && dadoscarteirinha.status == "Ativo") ?
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                    <Card style={{ width: "12cm", border: "1px solid blacknpm" }}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm" }}>
                                <Row style={{ marginTop: "1cm" }}>
                                    <Col md="4">
                                        <LogoSistema identificacaoLogo={"logotipo"} width='100' />
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <p>{titleCard}</p>
                                    </Col>
                                    <Col md="4" className="text-right">
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='130' />
                                    </Col>
                                    <Col xs="6" md="3">
                                        <b>Código Cadastro - {setupSistema?.identificacao}: </b> <br />{dadoscarteirinha.codCadastro}
                                    </Col>
                                    <Col xs="6" md="3">
                                        <b>Data Validade Cadastro: </b> <br /> <span className="text-nowrap">{formataValidade(dadoscarteirinha.validade)}</span>
                                    </Col>
                                    <Col xs="6" md="3">
                                        <b>Placa: </b> <br />{dadoscarteirinha.placa}
                                    </Col>
                                    <Col xs="6" md="3">
                                        <b>Data Validade Veículo: </b> <br /> <span className="text-nowrap">{formataValidade(dadoscarteirinha.dataValidadeVeiculo)}</span>
                                    </Col>
                                    <Col md="12" className="mt-4">
                                        <b>{dadoscarteirinha.documento.length > 11 ? "CNPJ" : "CPF"}: </b> {dadoscarteirinha.documento}
                                    </Col>
                                    <Col md="12">
                                        <b>{dadoscarteirinha.documento.length > 11 ? "Razão Social" : "Nome"}: </b> {dadoscarteirinha.nome}
                                    </Col>
                                    <Col md="12">
                                        <b>Endereço: </b> {dadoscarteirinha.endereco}
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "2cm", marginBottom: "2cm" }}>
                                    <Col md="12" className="text-center">
                                        <QRCode value={setupSistema?.urL_WEB_ROC + "/empty/carteirinhaveiculo?protocolo=" + dadoscarteirinha.protocolo + "&veiculo=" + dadoscarteirinha.veiculo} />
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                :

                <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                    <Card style={{ width: "12cm", border: "1px solid blacknpm" }}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm" }}>
                                <Row style={{ marginTop: "1cm" }}>
                                    <Col md="4">
                                        <LogoSistema identificacaoLogo={"logotipo"} width='100' />
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <p>{titleCard}</p>
                                    </Col>
                                    <Col md="4" className="text-right">
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='130' />
                                    </Col>
                                    <Col md="12">
                                        <h5><b>Não é possível visualizar a carteirinha de um veículo inativo</b></h5>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>

            }
        </>
    );
}